export default __webpack_public_path__ + "static/media/logox1.67a897cd.svg";